var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.labelFor.length > 0)?_c('label',{attrs:{"for":_vm.labelFor}},[_vm._v("\n        "+_vm._s(_vm.labelPlaceholder)+"\n    ")]):_vm._e(),_vm._v(" "),_c('input',{staticClass:"form-control city-input",attrs:{"type":"text","placeholder":_vm.placeholder,"name":_vm.name,"readonly":""},domProps:{"value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }